import React, { useState } from 'react';
import { Card } from '../Card/Card';
import { Icon, icons } from './Icon';
import { IconName } from './IconName';
import { Tooltip } from '../Tooltip/Tooltip';

export function IconExample(): JSX.Element {
  const [color, setColor] = useState('#000000');

  return (
    <Card>
      <div>
        <div style={{ marginBottom: '15px' }}>
          <h3>Color</h3>
          <input type="text" value={color} onChange={(e) => setColor(e.target.value)} />
        </div>
        <div className="styleguide__icons" style={{ color }}>
          {Object.keys(icons).map((icon: IconName) => {
            return (
              <span key={`icons-${icon}`} className="styleguide__icon">
                <Tooltip reference={<Icon name={icon} key={icon} />} darkMode>
                  {icon}
                </Tooltip>
              </span>
            );
          })}
          <Icon loading name="trash" />
        </div>
      </div>
    </Card>
  );
}
